<template>
  <v-card-text class="px-0 py-0">
    <v-tooltip left>
      <v-btn
        fixed
        dark
        bottom
        right
        fab
        class="mt-5 mr-2"
        :to="{ name: 'RecipientMultiplesNew' }"
        slot="activator"
        color="accent"><v-icon>add</v-icon>
      </v-btn>
      <span>Criar um novo envio</span>
    </v-tooltip>
    <v-card-title class="pt-0">
      <h2 class="main-title">Importar Destinatários</h2>

      <v-spacer></v-spacer>

      <v-flex xs12 sm5 md3>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Buscar"
          single-line
          hide-details
        ></v-text-field>
      </v-flex>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="batches"
      :search="search"
      class="table-transparent table-sticky"
    >
      <template v-slot:items="props">
        <tr :class="{'table--selected': recipientId === props.item.id}">
          <td>{{ props.item.fileName }}</td>
          <td>{{ props.item.fileSize }}</td>
          <td>{{ props.item.totalCount }}</td>
          <td>{{ $t(props.item.state) }} </td>
          <td>{{ $d(props.item.insertedAt.toDate(), 'long') }}</td>
        </tr>
      </template>
      <v-alert v-slot:no-results :value="true" color="error" icon="warning">
        Your search for "{{ search }}" found no results.
      </v-alert>
    </v-data-table>
    <router-view />
  </v-card-text>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'RecipientMultipleIndex',
    data () {
      return {
        search: '',
        recipientId: null,
        headers: [
          { text: 'Arquivo', value: 'fileName' },
          { text: 'Tamanho', value: 'fileSize' },
          { text: 'Total', value: 'totalCount' },
          { text: 'Status', value: 'state' },
          { text: 'Criado em', value: 'insertedAt' }
        ]
      }
    },
    computed: {
      ...mapGetters({
        batches: 'batches/list'
      })
    },
    methods: {
      resetRecipientId () {
        this.recipientId = null
      },
      setFowardId () {
        this.recipientId = parseInt(this.$route.params.recipientId)
      },
      changeRouter () {
        this.$route.name === 'RecipientIndex' ? this.resetRecipientId() : this.setFowardId()
      }
    },
    watch: {
      '$route': 'changeRouter'
    },
    beforeMount () {
      this.$store.dispatch('batches/getList')
    },
    mounted () {
      this.setFowardId()
    }
  }
</script>
